// src/components/cta/cta.component.js
import template from './cta.tpl.html';
import modaltemp from './modal.tpl.html';
import './cta.scss';

class CTAController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = [
    "$window", "$compile", "$scope", "$timeout", "$attrs", "AppService", "PageService", "userService"
  ];

  /** @ngInject */
  constructor($window, $compile, $scope, $timeout, $attrs, AppService, PageService, userService) {

    Object.assign(this, {
      $window, $compile, $scope, $timeout, $attrs,
      AppService, PageService, $userService: userService
    });

    this.progress = 0;
    this.modalRef = null;
    this.myTimeoutPromise = null;
    this.page = undefined; // Initialize page property
  }

  // Made $onInit async to await PageService call
  async $onInit() {
    // Fetch the page object
    this.page = await this.PageService.getGlobalPage();

    if (!this.page) {
      console.warn('CTAController: Page object not available from PageService. Some features may not work.');
      // You might want to disable certain features or show a fallback
      return;
    }
    const opts = this.page?.options || {};
    this.button = opts.button || {};
    this.text = this.btntext || this.button.text;
    this.link = this.action || this.button.action;
    this.target = this.target || this.button.target;
    this.btnclass = this.btnclass || 'btn btn-warning btn-lg';
    this.align = this.btnalign || 'text-center';
    this.arrow = this.btnarrow !== undefined ? this.btnarrow : true;
    this.form = opts.hsform;
    this.initModalContainer();
  }

  // Ensure modal container exists ONCE per page load
  initModalContainer() {
    this.modalRef = document.getElementById('modal');
    if (!this.modalRef) {
      this.modalRef = document.createElement('div');
      this.modalRef.id = "modal";
      this.modalRef.className = "modal fade";
      this.modalRef.tabIndex = -1;
      document.body.appendChild(this.modalRef);
    }
  }

  // Open modal and compile content
  optin($e) {
    this.progress = 0;
    import(/* webpackChunkName: "modalService" */ '@common/services/modal.service').then(({ ModalService }) => {
      this._modalService = new ModalService();
      // Assuming initModal can take a template path directly
      this._modalService.initModal(modaltemp);
      this.$compile(this.modalRef)(this.$scope);
      this.$scope.$applyAsync(); // Use $scope.$applyAsync instead of $rootScope.$applyAsync
    }).catch(error => {
      console.error("CTAController: Error loading or initializing ModalService:", error);
    });
  }

  // Main CTA click logic
  async onClick() {
    const alink = document.createElement('a');
    alink.target = '_blank';
    const email = this.$userService.email;
    const isAlumni = !!this.$attrs.alumni;

    if (email && isAlumni) {
      const alumniCookie = this.$userService.getCookie('alumni');
      const encodedEmail = this.PageService.base64_encode(email);

      if (alumniCookie === encodedEmail) {
        alink.href = this.AppService.cta(this.button.bookcall);
        alink.click();
      } else {
        try {
          const result = await this.PageService.getRow(`validate/alumni/${email}`);
          if (result?.data?.status === 'ok') {
            this.$userService.setCookie('alumni', encodedEmail, 1);
            alink.href = this.AppService.cta(this.button.bookcall);
          } else {
            alink.href = this.AppService.cta(this.button.action2);
          }
          alink.click();
        } catch (err) {
          console.error("CTAController: Error validating alumni:", err);
          alink.href = this.AppService.cta(this.button.action2);
          alink.click();
        }
      }
    } else {
      alink.href = this.AppService.cta(this.button.action2);
      alink.click();
    }
  }

  // Smooth scroll to anchor
  scrollTo(target) {
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  }

  setPwyc(pwyc) {
    if (!this.form?.redirect) return;
    this.form.redirect += '?' + this.AppService.appendParam('pwyc', pwyc);
    this.$window.open(this.form.redirect, '_blank');
  }

  // Coupon validation (async/await style)
  async validateFormCoupon(ngform) {
    if (!ngform.$valid) return ngform.$submitted = true;
    try {
      const result = await this.PageService.post('page/validate/tygl/coupon', this.user);
      if (result?.data?.status === 'ok') {
        this.error = false;
        this.progress = 50;
        // Access options via this.page (fetched in $onInit)
        this.page.options.opform.properties = { email: this.user.femail };
      } else {
        this.error = true;
      }
    } catch (error) { // Catch the error to log it
      console.error("CTAController: Error validating coupon:", error);
      this.error = true;
    }
  }

  async validateSOSCode(ngform) {
    if (!ngform.$valid) return ngform.$submitted = true;
    try {
      const result = await this.PageService.getRow('page/verify/' + this.user.coupon);
      this.error = !(result?.data?.status === 'ok');
      if (!this.error) this.progress = 50;
    } catch (error) { // Catch the error to log it
      console.error("CTAController: Error validating SOS code:", error);
      this.error = true;
    }
  }

  setActionCookie(progress, cookie, redirect) {
    this.progress = progress;
    this.delayRedirect(redirect.link, redirect.delay, cookie);
  }

  delayRedirect(redirect, delay, cookie) {
    let counter = delay;
    const tick = () => {
      if (counter > 0) {
        counter--;
        this.myTimeoutPromise = this.$timeout(tick, 1000);
      } else {
        if (cookie) {
          this.$userService.setCookie(cookie.name, cookie.value, cookie.expire);
        }
        // Safely call hideModal if _modalService exists
        this._modalService?.hideModal?.();
        this.$window.open(redirect, "_blank");
      }
    };
    this.myTimeoutPromise = this.$timeout(tick, 1000);
  }

  $onDestroy() {
    if (this.myTimeoutPromise) {
      this.$timeout.cancel(this.myTimeoutPromise);
    }
    this._modalService?.hideModal?.(); // Safely hide modal on destroy
  }
}

class CTAComponent {
  bindings = {
    btntext: '@?',
    action: '@?',
    target: '@?',
    btnclass: '@?',
    btnarrow: '@?',
    btnalign: '@?'
  };
  template = template;
  controller = CTAController;
}

export default angular
  .module('mrscta.component', [])
  .component('mrscta', new CTAComponent())
  .name;